import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import '../styles/Login.css';

// Asegurarse de que la clase login-bg tenga el gradiente en Login.css

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const { resetPassword } = useAuth();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm();

  const password = watch('password');

  useEffect(() => {
    if (!token) {
      toast.error('Token de recuperación inválido');
      navigate('/forgot-password');
    }
  }, [token, navigate]);

  const onSubmit = async (data) => {
    setLoading(true);
    
    try {
      const result = await resetPassword(token, data.password);
      
      if (result.success) {
        toast.success('Contraseña actualizada exitosamente');
        navigate('/login');
      } else {
        toast.error(result.error);
      }
    } catch (error) {
      toast.error('Error inesperado al restablecer contraseña');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-bg d-flex align-items-center justify-content-center min-vh-100" style={{ minHeight: '100vh', width: '100vw' }}>
        <div className="auth-card shadow-lg rounded-4 p-4" style={{ background: 'rgba(255,255,255,0.97)', minWidth: 340, maxWidth: 400 }}>
          <div className="text-center mb-4">
            <i className="bi bi-file-pdf display-4 text-primary mb-2"></i>
            <h1 className="fw-bold mb-1" style={{ letterSpacing: 1, fontSize: '2.2rem' }}>DataExtractor</h1>
          </div>
          <h2 className="text-center">Token Inválido</h2>
          <p style={{ textAlign: 'center', margin: '1rem 0', color: '#666' }}>
            El enlace de recuperación es inválido o ha expirado.
          </p>
          <div className="auth-links text-center mt-3">
            <Link to="/forgot-password">Solicitar nuevo enlace</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-bg d-flex align-items-center justify-content-center min-vh-100" style={{ minHeight: '100vh', width: '100vw' }}>
      <div className="auth-card shadow-lg rounded-4 p-4" style={{ background: 'rgba(255,255,255,0.97)', minWidth: 340, maxWidth: 400 }}>
        <div className="text-center mb-4">
          <i className="bi bi-file-pdf display-4 text-primary mb-2"></i>
          <h1 className="fw-bold mb-1" style={{ letterSpacing: 1, fontSize: '2.2rem' }}>DataExtractor</h1>
          <div className="text-muted mb-2" style={{ fontSize: '1.1rem' }}>Restablecer Contraseña</div>
        </div>
        <p style={{ textAlign: 'center', margin: '1rem 0', color: '#666' }}>
          Ingresa tu nueva contraseña.
        </p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group mb-3">
            <label htmlFor="password" className="form-label">Nueva Contraseña</label>
            <input
              type="password"
              id="password"
              className="form-control"
              {...register('password', {
                required: 'La contraseña es requerida',
                minLength: {
                  value: 6,
                  message: 'La contraseña debe tener al menos 6 caracteres'
                }
              })}
              placeholder="Tu nueva contraseña"
            />
            {errors.password && (
              <div className="error-message">{errors.password.message}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label htmlFor="confirmPassword" className="form-label">Confirmar Contraseña</label>
            <input
              type="password"
              id="confirmPassword"
              className="form-control"
              {...register('confirmPassword', {
                required: 'Confirma tu contraseña',
                validate: value =>
                  value === password || 'Las contraseñas no coinciden'
              })}
              placeholder="Confirma tu nueva contraseña"
            />
            {errors.confirmPassword && (
              <div className="error-message">{errors.confirmPassword.message}</div>
            )}
          </div>
          <button 
            type="submit" 
            className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2 mb-3"
            disabled={loading}
            style={{ fontWeight: 600, fontSize: '1.1rem' }}
          >
            <i className="bi bi-key"></i>
            {loading ? 'Actualizando...' : 'Actualizar Contraseña'}
          </button>
        </form>
        <div className="auth-links text-center mt-3">
          <Link to="/login">Volver al inicio de sesión</Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
